<template>
  <portal to="body">
    <div
      v-if="isOpen"
      class="fixed top-0 left-0 right-0 bottom-0"
      :class="size === 'full' ? '' : 'flex items-center justify-center'"
      :style="{ zIndex: zIndex }"
      @mousedown="handleOverlayMouseDown"
      @click="handleOverlayClick"
      data-testid="modal-overlay"
    >
      <div
        class="fixed top-0 left-0 right-0 bottom-0 bg-black opacity-75"
        :style="{ zIndex: -1 }"
      ></div>

      <div
        data-testid="modal-container"
        role="dialog"
        aria-modal="true"
        :class="[
          'bg-white',
          size !== 'custom' ? sizeStyles[size] : '',
          size === 'full'
            ? 'm-0 w-full h-full rounded-none flex flex-col'
            : 'm-4 w-full flex flex-col',
          className
        ]"
        :style="modalInlineStyles"
      >
        <div
          data-testid="modal-body"
          :class="[
            size === 'full' ? 'flex-1 overflow-y-scroll' : '',
            bodyClassName
          ]"
          :style="bodyInlineStyles"
        >
          <slot />
        </div>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  name: "Modal",
  props: {
    isOpen: { type: Boolean, required: true },
    closeOnOverlayClick: { type: Boolean, default: true },
    closeOnEscape: { type: Boolean, default: true },
    size: {
      type: String,
      default: "full",
      validator(value) {
        return ["sm", "md", "lg", "xl", "full", "custom"].indexOf(value) !== -1;
      }
    },
    width: { type: String, default: "" },
    height: { type: String, default: "" },
    className: { type: String, default: "" },
    bodyClassName: { type: String, default: "" },
    zIndex: { type: Number, default: 1000 }
  },
  data() {
    return {
      overlayMouseDownOnSelf: false,
      sizeStyles: {
        sm: "max-w-sm max-h-screen",
        md: "max-w-md max-h-screen",
        lg: "max-w-lg max-h-screen",
        xl: "max-w-xl max-h-screen",
        full: "w-full h-full",
        custom: ""
      }
    };
  },
  computed: {
    modalInlineStyles() {
      const customSize =
        this.size === "custom"
          ? {
              width: this.width || "auto",
              height: this.height || "auto"
            }
          : {};
      return Object.assign(
        {
          position: "relative",
          zIndex: 1,
          borderRadius: "4px",
          backgroundColor: "#FFFFFF",
          boxShadow: "0 10px 10px 0 rgba(0, 0, 0, 0.04), 0 20px 25px 0 rgba(0, 0, 0, 0.10)",
          padding: "20px"
        },
        customSize
      );
    },
    bodyInlineStyles() {
      return {
        backgroundColor: "#FFFFFF"
      };
    }
  },
  watch: {
    isOpen: {
      immediate: true,
      handler(open) {
        if (open) {
          document.body.style.overflow = "hidden";
          document.addEventListener("keydown", this.handleEscape);
        } else {
          document.body.style.overflow = "";
          document.removeEventListener("keydown", this.handleEscape);
        }
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleEscape);
    document.body.style.overflow = "";
  },
  methods: {
    handleEscape(event) {
      if (event.key === "Escape" && this.closeOnEscape) {
        this.$emit("close");
      }
    },
    handleOverlayMouseDown(event) {
      this.overlayMouseDownOnSelf = event.target === event.currentTarget;
    },
    handleOverlayClick(event) {
      const mouseDownOnSelf = this.overlayMouseDownOnSelf;
      this.overlayMouseDownOnSelf = false;
      if (event.target === event.currentTarget && mouseDownOnSelf && this.closeOnOverlayClick) {
        this.$emit("close");
      }
    }
  }
};
</script>